import DbClient from "./dbClient";

const db = new DbClient();
export default db;



// WEBPACK FOOTER //
// ./src/state/persistence/db.js